import { render, staticRenderFns } from "./LogReverse.vue?vue&type=template&id=99975d80"
import script from "./LogReverse.vue?vue&type=script&lang=js"
export * from "./LogReverse.vue?vue&type=script&lang=js"
import style0 from "./LogReverse.vue?vue&type=style&index=0&id=99975d80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports